export const SET_FILE_LIST = 'filebrowser/set-file-list';
export const SET_PATH_INFO = 'filebrowser/set-path-info';
